<div class="d-grid gap-3">
	<h4 class="gen-title">{{ "accountant" | langVal }}</h4>
	<div class="d-flex gap-3">
		<div
			[hidden]="scheduledReport.is_new_contact == 'yes'"
			class="colstat-big"
		>
			<app-gen-autocomplete
				#personFuzzyInput
				title_ph_lang="name"
				autofocus
				tabindex="1"
				[fuzzySearchableClasses]="['contacts']"
				[actualObj]="scheduledReport"
				fieldName="contact_id"
				[error]="errors.contact_id"
				(chosenEvent)="handleContactChange($event)"
			/>
		</div>
		<div>
			<button
				class="btn btn-icon"
				titleLang="add_new_contact"
				(click)="addNew()"
				[icon]="scheduledReport.is_new_contact == 'yes' ? 'minus' : 'plus'"
			></button>
		</div>
		@if (scheduledReport.is_new_contact == "yes" || contactNeedsEmail) {
			<div class="col-9 col-md-7">
				<div class="row">
					@if (scheduledReport.is_new_contact == "yes") {
						<div class="col-11 col-md-6">
							<app-gen-input
								autocomplete="off"
								[actualObj]="scheduledReport"
								[errors]="errors"
								fieldName="name"
								(keyupEvent)="validateEntireForm()"
							/>
						</div>
					}
					<div class="col-11 col-md-3">
						<app-gen-input
							autocomplete="off"
							[actualObj]="scheduledReport"
							[errors]="errors"
							fieldName="email"
							(keyupEvent)="validateEntireForm()"
						/>
					</div>
				</div>
			</div>
		}
	</div>

	<div class="d-flex gap-2">
		@for (checkbox of checkboxes; track checkbox) {
			<div class="reports">
				<input
					type="checkbox"
					[(ngModel)]="scheduledReport[checkbox]"
					[checked]="scheduledReport[checkbox]"
					(change)="validateEntireForm()"
				/>
				<label (click)="flipCheck(checkbox)">
					<h4>{{ checkbox | langVal }}</h4>
				</label>
			</div>
		}
	</div>
	@if (errors.checkboxes) {
		<p class="error">{{ errors.checkboxes }}</p>
	}

	<div class="d-flex gap-5">
		<div>
			<label>{{ "file_format" | langVal }}</label>
			<app-gen-button-group
				[actualObj]="scheduledReport"
				fieldName="file_format"
				optionsListName="file_format_opts"
				(changeEvent)="validateEntireForm()"
			/>
		</div>
		<div>
			<label>{{ "send_freq" | langVal }}</label>
			<app-gen-button-group
				[actualObj]="scheduledReport"
				fieldName="send_freq"
				optionsListName="send_freq_opts"
				(changeEvent)="validateEntireForm()"
			/>
		</div>
		<div>
			<label>{{ "date_in_month" | langVal }}</label>
			<app-gen-button-group
				[actualObj]="scheduledReport"
				fieldName="date_in_month"
				optionsListName="date_in_month_opts"
				(changeEvent)="validateEntireForm()"
			/>
		</div>
	</div>

	<div>
		<app-btn-ext
			text="accountant_insert"
			tabindex="21"
			[disabled]="!isFormSubmittable"
			(clickEv)="save()"
			[isSpin]="isSaving"
		/>
	</div>
</div>

<app-gen-table
	#scheduledReportsTbl
	tableName="scheduled_reports"
/>
<div>
	<app-btn-ext
		text="resend_all_reports"
		(clickEv)="send_all_reports()"
		[isSpin]="isSendingAll"
	/>
</div>
